module.exports = __webpack_public_path__ + "static/media/info.2cdcac22.svg";